var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useMediaQuery } from 'usehooks-ts';
const cleanUpThemes = (brandId, prefersDarkScheme) => {
    const themeLinkElements = Array.from(document === null || document === void 0 ? void 0 : document.querySelectorAll(`link[rel="stylesheet"][href*="${brandId}"]`));
    if (themeLinkElements.length > 1) {
        const oldTheme = themeLinkElements.find((link) => prefersDarkScheme ? !link.href.includes('-dark') : link.href.includes('-dark'));
        oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.remove();
    }
};
export const ThemeProvider = ({ brand, children, shouldSupportDarkMode = false, }) => {
    const prefersDarkScheme = useMediaQuery('(prefers-color-scheme: dark)');
    useEffect(() => {
        const loadTheme = (brandId) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const addDarkTheme = (_a = (shouldSupportDarkMode && prefersDarkScheme)) !== null && _a !== void 0 ? _a : false;
            try {
                yield import(
                /* webpackChunkName: "[request]" */ `../../themes/${brandId}/theme${addDarkTheme ? '-dark' : ''}.css`).finally(() => cleanUpThemes(brandId, prefersDarkScheme));
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
            }
            catch (error) {
                yield import(/* webpackChunkName: "default-theme-css" */ '../../themes/default/theme.css');
            }
        });
        loadTheme(brand);
    }, [brand, prefersDarkScheme, shouldSupportDarkMode]);
    return _jsx(_Fragment, { children: children });
};
